(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["new_small_slider"] && !window.DesignMode) return;
  try {
    

$('#home_small_slider').slick({
  dots: true,
  speed: 300,
  arrows: true,
  autoplay: true,
  slidesToShow: 1,
  autoplaySpeed: 2000,
  asNavFor: '.slide_list'
});



  } catch(e) { console.error(e); }
})();

})();
